/**
 */
define('constant/myservices/myservice.package.constant',[], function () {
    //一级分类
    var parentType =  [
        {key:"13",value:"应用"},
        {key:"2",value:"游戏"}
    ];
    var parentType4Server = [
        {key: "13", value: "应用"}];

    var parentType4AppTouch =[
        {key:"21",value:"AppTouch"}
    ];
    var parentType4IosNative =[
        {key:"22",value:"iosNative"}
    ];

    var languageWebAppList = [
        {key:"zh-CN",value:"简体中文",flag:false}
    ];

    var languageAppList =[
        {key: "zh-CN", value: "简体中文", flag: false}, {key: "zh-HK", value: "香港（中国）繁体中文", flag: false},
        {key: "zh-TW", value: "台湾（中国）繁体中文", flag: false}, {key: "en-US", value: "美式英语", flag: false},
        {key: "en-GB", value: "英式英语", flag: false}, {key: "es-ES", value: "欧洲西语", flag: false},
        {key: "pt-PT", value: "欧洲葡语", flag: false}, {key: "fr-FR", value: "法语", flag: false},
        {key: "de-DE", value: "德语", flag: false}, {key: "ru-RU", value: "俄语", flag: false},
        {key: "it-IT", value: "意大利语", flag: false}, {key: "ja-JP", value: "日语", flag: false},
        {key: "es-419", value: "拉美西语", flag: false}, {key: "pt-BR", value: "巴西葡语", flag: false},
        {key: "sv-SE", value: "瑞典语", flag: false}, {key: "no-NO", value: "挪威语", flag: false},
        {key: "da-DK", value: "丹麦语", flag: false}, {key: "cs-CZ", value: "捷克语", flag: false},
        {key: "hu-HU", value: "匈牙利语", flag: false}, {key: "sk", value: "斯洛伐克语", flag: false},
        {key: "pl-PL", value: "波兰语", flag: false}, {key: "ro", value: "罗马尼亚语", flag: false},
        {key: "el-GR", value: "希腊语", flag: false}, {key: "sr", value: "塞尔维亚语", flag: false},
        {key: "bs", value: "波斯尼亚语", flag: false}, {key: "mk-MK", value: "马其顿语", flag: false},
        {key: "bg", value: "保加利亚语", flag: false}, {key: "fi-FI", value: "芬兰语", flag: false},
        {key: "et", value: "爱沙尼亚语", flag: false}, {key: "lv", value: "拉脱维亚语", flag: false},
        {key: "lt", value: "立陶宛语", flag: false}, {key: "sl", value: "斯洛文尼亚语", flag: false},
        {key: "hr", value: "克罗地亚语", flag: false}, {key: "uk", value: "乌克兰语", flag: false},
        {key: "tr-TR", value: "土耳其语", flag: false}, {key: "vi", value: "越南语", flag: false},
        {key: "id", value: "印尼语", flag: false}, {key: "ar", value: "阿拉伯语", flag: false},
        {key: "nl-NL", value: "荷兰语", flag: false}, {key: "th", value: "泰语", flag: false},
        {key: "ms", value: "马来西亚语", flag: false}, {key: "ca", value: "加泰罗尼亚语", flag: false},
        {key: "hi-IN", value: "印地语", flag: false}, {key: "ko-KR", value: "韩语", flag: false},
        {key: "he_IL", value: "希伯来语", flag: false}, {key: "gl-ES", value: "加利西亚语", flag: false},
        {key: "eu-ES", value: "巴斯克语", flag: false}, {key: "ka-GE", value: "格鲁吉亚语", flag: false},
        {key: "az-AZ", value: "阿塞拜疆语", flag: false}, {key: "uz", value: "乌兹别克语", flag: false},
        {key: "km-KH", value: "高棉语", flag: false}, {key: "si-LK", value: "僧伽罗语", flag: false},
        {key: "ur", value: "乌尔都语", flag: false}, {key: "bo", value: "藏语", flag: false},
        {key: "be", value: "白俄罗斯语", flag: false}, {key: "kk", value: "哈萨克语", flag: false},
        {key: "bn-BD", value: "孟加拉语", flag: false}, {key: "lo-LA", value: "老挝语", flag: false},
        {key: "jv", value: "爪哇语", flag: false}, {key: "ne-NP", value: "尼泊尔语", flag: false},
        {key: "fa", value: "波斯语", flag: false}, {key: "my-MM", value: "缅甸语", flag: false},
        {key: "fil", value: "菲律宾语", flag: false},{key: "sw_TZ", value: "斯瓦西里语", flag: false},
        {key: "mi_NZ", value: "毛利语", flag: false},{key: "am_ET", value: "阿姆哈拉语", flag: false},
        {key: "te_IN", value: "泰卢固语", flag: false},{key: "mr_IN", value: "马拉地语", flag: false},
        {key: "ta_IN", value: "泰米尔语", flag: false},{key: "gu_IN", value: "古吉拉特语", flag: false},
        {key: "kn_IN", value: "卡纳达语", flag: false},{key: "ml_IN", value: "马来亚拉姆语", flag: false},
        {key: "or_IN", value: "欧里亚语", flag: false},{key: "pa_Guru_IN", value: "旁遮普语", flag: false},
        {key: "as_IN", value: "阿萨姆语", flag: false},{key: "mai_Deva_IN", value: "迈蒂利语", flag: false},
        {key: "mn_MN", value: "蒙古语（西里尔文）", flag: false}
    ];

    var languageVrList = [
        {key:"zh-CN",value:"简体中文",flag:false},
        {key:"zh-HK",value:"香港（中国）繁体中文",flag:false},
        {key:"zh-TW",value:"台湾（中国）繁体中文",flag:false},
        {key:"en-US",value:"美式英语",flag:false},
        {key:"en-GB",value:"英式英语",flag:false}
    ];

    var languageTVList = [{key:"zh-CN", value:"简体中文"}, {key:"en-US", value:"美式英语"}];
    var languageIosList =[
        {key:"zh-CN",value:"简体中文"},
        {key:"en-GB",value:"英式英语"},
        {key:"en-US",value:"美式英语"}
        ];

    var languageWatchList =  [
        {key:"zh-CN",value:"简体中文"},
        {key:"zh-HK",value:"香港（中国）繁体中文"},
        {key:"zh-TW",value:"台湾（中国）繁体中文"},
        {key:"en-GB",value:"英式英语"},
        {key:"en-US",value:"美式英语"}
    ];
    var languageDynamicWpList =
        [{key: "zh-CN", value: "简体中文"},{key: "en-US", value: "美式英语"}];

    var languageFontList =
        [{key: "zh-CN", value: "简体中文"},{key: "en-US", value: "美式英语"}];

    var  languageWallPaperList =
        [{key: "zh-CN", value: "简体中文"},{key: "en-US", value: "美式英语"}];


    return {
        parentType:parentType,
        languageWebAppList:languageWebAppList,
        languageAppList:languageAppList,
        languageVrList:languageVrList,
        languageTVList:languageTVList,
        languageWatchList:languageWatchList,
        languageDynamicWpList:languageDynamicWpList,
        languageFontList:languageFontList,
        languageWallPaperList:languageWallPaperList,
        prodTypeAutoDelete:["15","17","20"],//字体，主题，动态壁纸 如果包校验失败，Openapp调删除包接口，前台不用调
        getPackageListApi: {
            '1': 'getAppApkList',
            '2': 'getAppApkList',
            '3': 'getAppApkList',
            '8': 'getAppApkList',
            '9': 'getAppApkList',
            '14': 'getThemePkgList',
            '15': 'getWpPkgList',
            '19': 'getAppRpkList',
            '17': 'getFontPkgList',
            '20': 'getDynamicWpPkgList',
            '23': 'getAppRpkList'
        },
        getPackageListApiParam: {
            'getAppApkList': 'appID',
            'getThemePkgList': 'themeID',
            'getWpPkgList': 'wpID',
            'getAppRpkList': 'appID',
            'getDynamicWpPkgList':'dynamicWpID',
            'getFontPkgList': 'fontID'
        },
        packageIsFirstFinished: {
            '1': {
                prodType: "prodType",
                prodID: "prodID",
                pkgVersion: "pkgVersion"
            }, '2': {}, '3': {}, '8': {}, '9': {}, '14': {}, '15': {}, '19-1': {}, '19-2': {}, '20': {}
        },
        packageIsUpdateFinished: {
            '1': {
                pkgVersion: "pkgVersion"
            }, '2': {}, '3': {}, '8': {}, '9': {}, '14': {}, '15': {}, '19-1': {}, '19-2': {}, '17': {}, '20': {}
        },
        needAutoAddSer: [4, 5, 24, 40, 30, 53, 45],
        newProductHtml: {
            '1': {
                productName: "移动应用",
                tempHtml: "pages/myservices/common/new-app.html",
                parentType: parentType,
                languageList: languageAppList,
                addProduct: 'addApp'
            },
            '2': {
                productName: "智慧屏应用",
                tempHtml: "pages/myservices/common/new-app.html",
                parentType: parentType,
                languageList: languageTVList,
                addProduct: 'addApp'
            },
            '7': {
                productName: "服务器应用",
                tempHtml: "pages/myservices/common/new-server.html",
                parentType: parentType4Server,
                languageList: languageWebAppList,
                addProduct: 'addApp'
            },
            '8': {
                productName: "华为VR应用",
                tempHtml: "pages/myservices/common/new-vr.html",
                parentType: parentType,
                languageList: languageVrList,
                addProduct: 'addApp'
            },
            '9': {
                productName: "手表应用",
                tempHtml: "pages/myservices/common/new-app.html",
                parentType: parentType,
                languageList: languageWatchList,
                addProduct: 'addApp'
            },
            '18': {},
            '19-1': {
                productName: "快应用",
                tempHtml: "pages/myservices/common/new-freeinstall-app.html",
                parentType: parentType,
                languageList: languageAppList,
                addProduct: 'addFreeApp'
            },
            '19-2': {
                productName: "免安装/H5应用",
                tempHtml: "pages/myservices/common/new-freeinstall-h5.html",
                parentType: parentType,
                languageList:languageWebAppList,
                addProduct:'addFreeApp'
            },
            '21': {
                productName: "AppTouch应用",
                tempHtml: "pages/myservices/common/new-app.html",
                parentType: parentType4AppTouch,
                languageList: languageAppList,
                addProduct: 'addApp'
            },
            '22': {
                productName: "IOS移动应用",
                tempHtml: "pages/myservices/common/new-server.html",
                parentType: parentType4IosNative,
                languageList: languageIosList,
                addProduct: 'addApp'
            } ,'23': {
                productName: "智慧屏快应用",
                tempHtml: "pages/myservices/common/new-freeinstall-app.html",
                parentType: parentType4Server,
                languageList: languageWebAppList,
                addProduct: 'addFreeApp'
            },'27': {
                productName: "车机应用",
                tempHtml: "pages/myservices/common/new-app.html",
                parentType: parentType,
                languageList: languageAppList,
                addProduct: 'addApp'
            },'28': {
                productName: "车机快应用",
                tempHtml: "pages/myservices/common/new-freeinstall-app.html",
                parentType: parentType,
                languageList: languageAppList,
                addProduct: 'addApp'
            },'42': {
                productName: "PC快应用",
                tempHtml: "pages/myservices/common/new-freeinstall-app.html",
                parentType: parentType,
                languageList: languageAppList,
                addProduct: 'addFreeApp'
            }
        },
        nextUrlSref: {
            '4-1': 'rollout.appDetail',
            '5-1': 'rollout.appDetail',
            '40-1': 'rollout.preloadServiceDetail',
            '24-2': 'rollout.tvDetail',
            '24-23':'rollout.tvDetail',
            '3': {},
            '4-8': 'rollout.vrDetail',
            '5-8': 'rollout.vrDetail',
            '9': '',
            '53-9': 'rollout.watchDetail',
            '30-14': 'rollout.wallpaperService',
            '30-15': 'rollout.wallpaperProduct',
            '30-17': 'rollout.fontProduct',
            '30-20': 'rollout.dynamicWpProduct',
            '4-19-1': 'rollout.freeDetail',
            '4-19-2': 'rollout.freeDetail'
        },
        hasPackageListProductType: ['1-4', '2-24', '8-4', '9-53', '1-40', '14-30', '15-30', '19-1-4','17-30','20-30','23-24'],
        hasOnlyProductType: {'26': 1, '53': 9},//只有一种产品可以添加的服务  服务项:产品类型
        notFinishedForm: {
            productType: {
                title: '产品类型',
                errorText: '请选择产品类型'
            },
            product: {
                title: '选择产品',
                errorText: '请选择产品'
            },
            webAppUrl: {
                title: '应用访问地址',
                errorText: '请输入正确的应用访问地址'
            },
            bundleId:{
                title:'BundleId',
                errorText:'请输入格式正确的BundleId，且不能和测试BundleId重复'
            },
            testBundleId:{
                title:'测试BundleId',
                errorText:'请输入格式正确的测试BundleId，且不能和BundleId重复'
            },
            packageSelected: {
                title: '产品包',
                errorText: '请选择产品包'
            },
            themePKGSelected: {
                title: '主题包',
                errorText: '请选择主题包'
            },
            dynamicWpPKGSelected: {
                title: '动态壁纸包',
                errorText: '请选择动态壁纸包'
            },
            wallpaperPKGSelected: {
                title: '壁纸包',
                errorText: '请选择壁纸包'
            },
            packageName: {
                title: '应用包名',
                errorText: '请输入正确的应用包名'
            },
            oauthCertFingerprint: {
                title: 'SHA256证书指纹',
                errorText: '请输入正确的证书指纹'
            },
            oauthCertFingerprint1: {
                title: 'SHA256证书指纹2',
                errorText: '请输入正确的证书指纹'
            },
            oauthCertFingerprint2: {
                title: 'SHA256证书指纹3',
                errorText: '请输入正确的证书指纹'
            },
            oauthCertFingerprint3: {
                title: 'SHA256证书指纹4',
                errorText: '请输入正确的证书指纹'
            },
            oauthCertFingerprint4: {
                title: 'SHA256证书指纹5',
                errorText: '请输入正确的证书指纹'
            },
            callbackUrl: {
                title: '回调地址',
                errorText: '请输入正确的回调地址'
            },
            url1: {
                title: '安全URL1',
                errorText: '请输入正确的URL'
            },
            url2: {
                title: '安全URL2',
                errorText: '请输入正确的URL'
            },
            url3: {
                title: '安全URL3',
                errorText: '请输入正确的URL'
            },
            url5: {
                title: '安全URL5',
                errorText: '请输入正确的URL'
            },
            url4: {
                title: '安全URL4',
                errorText: '请输入正确的URL'
            },
            sporthealthPowers: {
                title: '权限',
                errorText: '请至少选择一项权限'
            },
            email: {
                title: '邮箱',
                errorText: '请输入正确的邮箱'
            },
            phoneNum: {
                title: '客服电话',
                errorText: '请输入正确的客服电话'
            },
            website: {
                title: '网址',
                errorText: '请输入正确的官网地址'
            },
            //权签校验

            apkFile: {
                title: '应用APK包',
                errorText: '请上传APK包'
            },
            excelFile: {
                title: '开放API授权申请列表',
                errorText: '请上传开放API授权申请文件'
            },
            deviceInfo: {
                title: '开发设备列表',
                errorText: '请输入正确的设备号'
            },
            rightInfoListHidden: {
                title: '申请权限',
                errorText: '请勾选申请权限'
            },
            beginDate: {
                title: '证书有效期',
                errorText: '请选择证书有效开始日期'
            },
            endDate: {
                title: '证书有效期',
                errorText: '请选择证书有效结束日期'
            },

            certInfo: {
                title: 'HTTPS证书',
                errorText: '请输入正确的HTTPS证书'
            },
            cbUserName: {
                title: '回调用户名',
                errorText: '请输入正确的回调用户名'
            },
            cbSecret: {
                title: '回调秘钥',
                errorText: '请输入正确的回调秘钥'
            },
            appIcon:
            {
                title: '应用图标',
                errorText: '请输入正确的应用图标'
            }


        }
    }
});

